// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_country from "../../commonapis/gen/buhta_common_v1_country.js";
import * as Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup from "./buhta_control_v1alpha1_entity_lookup.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";

const Imported$pmodules = {};

const LookupEntityRequest = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_service.ml",
      309,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const LookupEntityResponse = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_service.ml",
      377,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.control.v1alpha1.LookupEntityRequest";
}

function make(countryOpt, tinOpt, ctxOpt, param) {
  const country = countryOpt !== undefined ? countryOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0);
  const tin = tinOpt !== undefined ? tinOpt : "";
  const ctx = ctxOpt !== undefined ? ctxOpt : Curry._1(Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.LookupCtx.from_int_exn, 0);
  return {
          country: country,
          tin: tin,
          ctx: ctx
        };
}

const merge_country = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "country",
            "country"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
          Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
        ]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_ctx = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "ctx",
            "ctx"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.LookupCtx),
          Curry._1(Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.LookupCtx.from_int_exn, 0)
        ]));

function merge(t1, t2) {
  return {
          country: Curry._2(merge_country, t1.country, t2.country),
          tin: Curry._2(merge_tin, t1.tin, t2.tin),
          ctx: Curry._2(merge_ctx, t1.ctx, t2.ctx)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "country",
                    "country"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
                  Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "tin",
                        "tin"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "ctx",
                            "ctx"
                          ],
                          Ocaml_protoc_plugin__Spec.$$enum(Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.LookupCtx),
                          Curry._1(Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.LookupCtx.from_int_exn, 0)
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.country, param.tin, param.ctx);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(country, tin, ctx) {
  return {
          country: country,
          tin: tin,
          ctx: ctx
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.LookupEntityRequest", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.country, param.tin, param.ctx);
  };
}

function constructor$1(country, tin, ctx) {
  return {
          country: country,
          tin: tin,
          ctx: ctx
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.LookupEntityRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, LookupEntityRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.control.v1alpha1.LookupEntityResponse";
}

function make$1(lookup_optOpt, param) {
  const lookup_opt = lookup_optOpt !== undefined ? lookup_optOpt : "not_set";
  return {
          lookup_opt: lookup_opt
        };
}

const $$let = Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.EntityLookupPerson;

const merge_oneof_lookup_opt__Person = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const $$let$1 = Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.EntityLookupOrg;

const merge_oneof_lookup_opt__Org = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$1(t1, t2) {
  const match = t1.lookup_opt;
  const match$1 = t2.lookup_opt;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Person") {
      if (typeof match$1 === "string" || match$1.NAME !== "Person") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Person",
          VAL: Curry._2(merge_oneof_lookup_opt__Person, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Org" && !(typeof match$1 === "string" || match$1.NAME !== "Org")) {
      tmp = {
        NAME: "Org",
        VAL: Curry._2(merge_oneof_lookup_opt__Org, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
          lookup_opt: tmp
        };
}

function spec$1(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.EntityLookupPerson;
  const $$let$1 = Buhta_controlapis__Buhta_control_v1alpha1_entity_lookup.Buhta.Control.V1alpha1.EntityLookupOrg;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
                  {
                    hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                          [
                            1,
                            "person",
                            "person"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: $$let.name,
                                make: $$let.make,
                                from_proto: $$let.from_proto,
                                from_proto_exn: $$let.from_proto_exn,
                                to_proto: $$let.to_proto,
                                to_proto$p: $$let.to_proto$p,
                                merge: $$let.merge,
                                to_json: $$let.to_json,
                                from_json_exn: $$let.from_json_exn,
                                from_json: $$let.from_json
                              }),
                          [
                            (function (v) {
                                return {
                                        NAME: "Person",
                                        VAL: v
                                      };
                              }),
                            (function (param) {
                                if (typeof param === "string") {
                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                            _1: "Cannot destruct given oneof"
                                          });
                                }
                                if (param.NAME === "Person") {
                                  return param.VAL;
                                }
                                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                          MEL_EXN_ID: Stdlib.Invalid_argument,
                                          _1: "Cannot destruct given oneof"
                                        });
                              })
                          ]
                        ]),
                    tl: {
                      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                            [
                              2,
                              "org",
                              "org"
                            ],
                            Ocaml_protoc_plugin__Spec.message({
                                  name: $$let$1.name,
                                  make: $$let$1.make,
                                  from_proto: $$let$1.from_proto,
                                  from_proto_exn: $$let$1.from_proto_exn,
                                  to_proto: $$let$1.to_proto,
                                  to_proto$p: $$let$1.to_proto$p,
                                  merge: $$let$1.merge,
                                  to_json: $$let$1.to_json,
                                  from_json_exn: $$let$1.from_json_exn,
                                  from_json: $$let$1.from_json
                                }),
                            [
                              (function (v) {
                                  return {
                                          NAME: "Org",
                                          VAL: v
                                        };
                                }),
                              (function (param) {
                                  if (typeof param === "string") {
                                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                              MEL_EXN_ID: Stdlib.Invalid_argument,
                                              _1: "Cannot destruct given oneof"
                                            });
                                  }
                                  if (param.NAME === "Org") {
                                    return param.VAL;
                                  }
                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                            _1: "Cannot destruct given oneof"
                                          });
                                })
                            ]
                          ]),
                      tl: /* [] */0
                    }
                  },
                  (function (param) {
                      if (typeof param === "string") {
                        return Stdlib.failwith("Impossible case");
                      } else if (param.NAME === "Org") {
                        return 1;
                      } else {
                        return 0;
                      }
                    })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.lookup_opt);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(lookup_opt) {
  return {
          lookup_opt: lookup_opt
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.LookupEntityResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.lookup_opt);
  };
}

function constructor$3(lookup_opt) {
  return {
          lookup_opt: lookup_opt
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.LookupEntityResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, LookupEntityResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

const lookupEntity_0 = {
  name: LookupEntityRequest.name,
  make: LookupEntityRequest.make,
  from_proto: LookupEntityRequest.from_proto,
  from_proto_exn: LookupEntityRequest.from_proto_exn,
  to_proto: LookupEntityRequest.to_proto,
  to_proto$p: LookupEntityRequest.to_proto$p,
  merge: LookupEntityRequest.merge,
  to_json: LookupEntityRequest.to_json,
  from_json_exn: LookupEntityRequest.from_json_exn,
  from_json: LookupEntityRequest.from_json
};

const lookupEntity_1 = {
  name: LookupEntityResponse.name,
  make: LookupEntityResponse.make,
  from_proto: LookupEntityResponse.from_proto,
  from_proto_exn: LookupEntityResponse.from_proto_exn,
  to_proto: LookupEntityResponse.to_proto,
  to_proto$p: LookupEntityResponse.to_proto$p,
  merge: LookupEntityResponse.merge,
  to_json: LookupEntityResponse.to_json,
  from_json_exn: LookupEntityResponse.from_json_exn,
  from_json: LookupEntityResponse.from_json
};

const lookupEntity = [
  lookupEntity_0,
  lookupEntity_1
];

const V1alpha1_EntityService = {
  LookupEntity: {
    name: "/buhta.control.v1alpha1.EntityService/LookupEntity",
    package_name: "buhta.control.v1alpha1",
    service_name: "EntityService",
    method_name: "LookupEntity",
    $$Request: {
      name: LookupEntityRequest.name,
      make: LookupEntityRequest.make,
      from_proto: LookupEntityRequest.from_proto,
      from_proto_exn: LookupEntityRequest.from_proto_exn,
      to_proto: LookupEntityRequest.to_proto,
      to_proto$p: LookupEntityRequest.to_proto$p,
      merge: LookupEntityRequest.merge,
      to_json: LookupEntityRequest.to_json,
      from_json_exn: LookupEntityRequest.from_json_exn,
      from_json: LookupEntityRequest.from_json
    },
    $$Response: {
      name: LookupEntityResponse.name,
      make: LookupEntityResponse.make,
      from_proto: LookupEntityResponse.from_proto,
      from_proto_exn: LookupEntityResponse.from_proto_exn,
      to_proto: LookupEntityResponse.to_proto,
      to_proto$p: LookupEntityResponse.to_proto$p,
      merge: LookupEntityResponse.merge,
      to_json: LookupEntityResponse.to_json,
      from_json_exn: LookupEntityResponse.from_json_exn,
      from_json: LookupEntityResponse.from_json
    }
  },
  lookupEntity: lookupEntity
};

const V1alpha1 = {
  LookupEntityRequest: LookupEntityRequest,
  LookupEntityResponse: LookupEntityResponse,
  EntityService: V1alpha1_EntityService
};

const Control = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Control: Control
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* LookupEntityRequest Not a pure module */
